var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link c-btn__back",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"ev-icon ev-icon-back c-btn__back__icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }